import script from "./chat.vue?vue&type=script&lang=ts&setup=true"
export * from "./chat.vue?vue&type=script&lang=ts&setup=true"

import "./chat.vue?vue&type=style&index=0&id=1015b23c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1015b23c"]])

export default __exports__